var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("b-table", {
    attrs: {
      fields: _vm.fields,
      items: _vm.items,
      "table-class": "text-nowrap",
      responsive: "",
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
    },
    on: {
      "update:sortBy": function ($event) {
        _vm.sortBy = $event
      },
      "update:sort-by": function ($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function ($event) {
        _vm.sortDesc = $event
      },
      "update:sort-desc": function ($event) {
        _vm.sortDesc = $event
      },
    },
    scopedSlots: _vm._u([
      {
        key: "cell(name)",
        fn: function (data) {
          return [
            _c("div", { staticClass: "d-flex align-items-center" }, [
              data.item.brand.logo_url
                ? _c(
                    "div",
                    { staticClass: "mr-2" },
                    [
                      _c("b-avatar", {
                        attrs: {
                          variant: "primary",
                          src: data.item.brand.logo_url,
                          size: "40px",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", [
                _c("h4", { staticClass: "mb-0" }, [
                  _vm._v(_vm._s(data.item.brand.name)),
                ]),
              ]),
            ]),
          ]
        },
      },
      {
        key: "cell(created_by)",
        fn: function (data) {
          return [
            _c(
              "b-link",
              {
                attrs: {
                  to: {
                    name: "admin-user",
                    params: { id: data.item.brand.created_by.id.toString() },
                  },
                },
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(data.item.brand.created_by.name) +
                    "\n    "
                ),
              ]
            ),
          ]
        },
      },
      {
        key: "cell(created_on)",
        fn: function (data) {
          return [
            _vm._v(
              "\n    " +
                _vm._s(_vm.convertFromUtc(data.item.created_on, "MM/DD/YYYY")) +
                "\n  "
            ),
          ]
        },
      },
      {
        key: "cell(status)",
        fn: function (data) {
          return [
            data.item.brand.is_approved
              ? _c("b-badge", { attrs: { variant: "success" } }, [
                  _vm._v("Approved"),
                ])
              : _c("b-badge", { attrs: { variant: "danger" } }, [
                  _vm._v("Not Approved"),
                ]),
          ]
        },
      },
      {
        key: "cell(actions)",
        fn: function (data) {
          return [
            _c(
              "no-permission-wrapper",
              { attrs: { show: !_vm.canApproveBrands } },
              [
                !data.item.brand.is_approved
                  ? _c(
                      "b-btn",
                      {
                        attrs: {
                          variant: "success",
                          disabled: !_vm.canApproveBrands,
                        },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.$emit("approve", data.item.brand)
                          },
                        },
                      },
                      [_vm._v("\n        Approve\n      ")]
                    )
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "no-permission-wrapper",
              { attrs: { show: !_vm.canDeleteBrands } },
              [
                _c(
                  "b-btn",
                  {
                    attrs: {
                      variant: "danger",
                      disabled: !_vm.canDeleteBrands,
                    },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.$emit("delete", data.item.brand)
                      },
                    },
                  },
                  [_vm._v("\n        Delete\n      ")]
                ),
              ],
              1
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }